import * as moment from 'moment';

import { Identifier, LogbookEntry, LogbookEntryDto } from '../../models';

export function toLogbookEntryDto(value: LogbookEntry, isBroadcast: boolean, isSingle: boolean = false): LogbookEntryDto{
    const group = value.group;
    const identifier = value.identifier;
    const begin = isSingle
        ? moment(value.range as unknown as moment.Moment).toISOString()
        : moment(value.range.startDate).toISOString();
    const end = isSingle
        ? undefined
        : moment(value.range.endDate).toISOString();

    const dto: LogbookEntryDto = {
        beginDateTime: begin,
        endDateTime: end,
        comment: value.comment,
        group: group,
        identifier: identifier as Identifier,
        logbookEntryId: value.id,
        labels: value.labels,
        severity: value.severity,
        user: value.user,
        userName: value.userName,
        isBroadcast: isBroadcast,
        orderId: 0,
        dateModified: moment(value.dateModified).toISOString()
    };
    return dto;
}

export function toLogbookEntry(d: LogbookEntryDto): LogbookEntry {
    return {
        id: d.logbookEntryId,
        range: {
            startDate: d.beginDateTime,
            endDate: d.endDateTime
        },
        comment: d.comment,
        severity: d.severity,
        user: d.user,
        userName: d.userName,
        group: d.group,
        identifier: d.identifier,
        labels: d.labels,
        orderId: d.orderId,
        dateModified: moment(d.dateModified).toISOString()
    };
}